import styled from 'styled-components';

const ModalDivider = styled.div`
  margin: 30px 0;
  border-top: 1px solid ${props => props.theme.wizard.divider};
`;

export default ModalDivider;
